<div class="wrapper-page">
  <app-my-content></app-my-content>
  <div class="wrapper-home-page">
    <tl-header></tl-header>
    <div class="wrapper-following-followers">
      <div class="wrapper-custom-tabs">
        <div class="custom-tab" [ngClass]="{'active': tabSelected === 'followers'}" (click)="selectTab('followers')">
          <span>{{profileData?.followers_count}} {{profileData?.followers_count > 1 ? ('INSIGHTS.followers' | translate
            ):
            ('INSIGHTS.followers' | translate)}}</span>
        </div>
        <div class="custom-tab" [ngClass]="{'active': tabSelected === 'following'}" (click)="selectTab('following')">
          <span>{{profileData?.followings_count}} {{'FOLLOWING_FOLLOWERS.following' | translate}}</span>
        </div>
      </div>
      <!--   TODO JS - Kad search sklanjas stvari koje nisu potrbne , pogledati dizajn.     -->
      <div class="wrapper-custom-search">
        <img class="icon-search" src="../../../assets/icons/outline/icon-search.svg" alt="">
        <input type="text" placeholder="Search..." [(ngModel)]="searchTerm" (input)="onSearchChange($event)">
        <div (click)="resetSearch()" class="wrapper-delete-search">
          <img src="../../../assets/icons/outline/icon-close.svg" alt="">
        </div>
      </div>
      <span class="title-following-followers">{{'FOLLOWING_FOLLOWERS.categories' | translate}}</span>
      <div class="wrapper-boxes-following-followers">
        <div class="wrapper-box-friends"
          [routerLink]="[PAGES_AND_PATHS.friendsExperts.pagePath, userId, username, tabSelected, 'friends']">
          <div class="box-images">
            <img *ngFor="let friend of friends"
              [src]="friend.profile_photo_url ? friend.profile_photo_url : '../../../../assets/images/avatar-user.png'"
              alt="">
          </div>
          <div class="box-info">
            <span class="text1">{{'FOLLOWING_FOLLOWERS.friends' | translate}}</span>
            <span *ngIf="loggedUser.id === profileData?.id" class="text2">{{tabSelected === 'followers' ? (
              'FOLLOWING_FOLLOWERS.friends_who_follows_you' | translate) : ('Friends you follow' | translate)}}</span>
            <span *ngIf="loggedUser.id !== profileData?.id" class="text2">{{tabSelected === 'followers' ? 'Friends who follows' : 'Friends who follow'}}</span>
          </div>
        </div>
        <div class="wrapper-box-friends purple"
          [routerLink]="[PAGES_AND_PATHS.friendsExperts.pagePath, userId, username, tabSelected, 'experts']">
          <div class="box-images">
            <img *ngFor="let expert of experts"
              [src]="expert.profile_photo_url ? expert.profile_photo_url : '../../../../assets/images/avatar-user-expert.png'"
              alt="">
          </div>
          <div class="box-info">
            <span class="text1">{{'FOLLOWING_FOLLOWERS.experts' | translate}}</span>
            <span *ngIf="loggedUser.id === profileData?.id" class="text2">{{tabSelected === 'followers' ?
              ('FOLLOWING_FOLLOWERS.experts_who_follows_you' | translate) : ('Experts you follow' | translate)}}</span>
            <span *ngIf="loggedUser.id !== profileData?.id" class="text2">{{tabSelected === 'followers' ? 'Experts who follows' : 'Experts who follow'}}</span>
          </div>
        </div>
      </div>
      <span class="title-following-followers">{{this.tabSelected === 'followers' ? ('FOLLOWING_FOLLOWERS.all_followers'
        | translate) : ('FOLLOWING_FOLLOWERS.all_following' | translate)}}</span>
      <div class="wrapper-list-users-ff" #followersContainer (scroll)="onScroll($event)">
        <div *ngFor="let user of users" class="wrapper-user-item" [ngClass]="{'expert': (user.subscriptions | checkActiveRole) === UserRoles.expert}">
          <div [routerLink]="[PAGES_AND_PATHS.profile.pagePath, user.username]" class="wrapper-info-user-ff">
            <div class="avatar-user">
              <img *ngIf="user.profile_photo_url === null" class="img-lister"
                [src]="(user.subscriptions | checkActiveRole) === UserRoles.expert ? '../../../../assets/images/avatar-user-expert.png' : '../../../../assets/images/avatar-user.png'"
                alt="">
              <img *ngIf="user.profile_photo_url !== null" [src]="user.profile_photo_url" alt="">
            </div>
            <span>{{user.name}}</span>
            <img *ngIf="(user.subscriptions | checkActiveRole) === UserRoles.expert"
                 src="../../../../assets/icons/fill/icon-badge.svg" alt="">
            <img *ngIf="(user.subscriptions | checkActiveRole) === UserRoles.company"
                 src="../../../../assets/icons/fill/icon-fill-company.svg" alt="">
          </div>
          <button *ngIf="tabSelected === 'followers' && profileData?.id === loggedUser.id"
            (click)="openRemoveModal(user)" class="custom-btn custom-btn--outline">
            <span>{{'FOLLOWING_FOLLOWERS.remove' | translate}}</span>
          </button>
          <button *ngIf="tabSelected === 'followers' && profileData?.id !== loggedUser.id && loggedUser.id !== user.id"
            (click)="followUnfollow(user)" class="custom-btn"
            [ngClass]="user.am_i_following_this_user ? 'custom-btn--outline' : 'custom-btn--primary'">
            <span>{{user.am_i_following_this_user ? ('FOLLOWING_FOLLOWERS.following' | translate) : ('GENERAL.follow' |
              translate)}}</span>
          </button>
          <button *ngIf="tabSelected === 'following' && loggedUser.id !== user.id" (click)="followUnfollow(user)"
            class="custom-btn"
            [ngClass]="user.am_i_following_this_user ? 'custom-btn--outline' : 'custom-btn--primary'">
            <span>{{user.am_i_following_this_user ? ('FOLLOWING_FOLLOWERS.following' | translate) : ('GENERAL.follow' |
              translate)}}</span>
          </button>
        </div>
      </div>
    </div>
  </div>
</div>

<tl-confirm-modal *ngIf="isRemoveUserModalOpen" [modalIcon]="'../../../../../assets/icons/outline/icon-delete.svg'"
  [modalTitle]="removeModalText.title" [confirmBtnText]="removeModalText.button"
  [modalDescription]="removeModalText.description" (cancelModal)="isRemoveUserModalOpen = false"
  (confirmModal)="takeAction()">
</tl-confirm-modal>
